import React from "react";
import "../../Styles/yellowcalf.css/Payment_Mode_Report.css";

function Payment_Mode_Report() {
  return (
    <div className="payment-mode-container" style={{ paddingTop: "25px" }}>
      <div className="payment-mode-header">
        <h3>Payment Mode Report</h3>
        <div className="export-btn-container-payment">
          <button className="export-btn-payment">
            Export <span className="arrow-down-payment"></span>
          </button>
        </div>
      </div>

      {/* Filter + Table Section */}
      <div className="payment-mode-body">
        <div className="filter-section-payment">
          <select className="parent-select-payment">
            <option value="">Select Parent</option>
          </select>
          <button className="search-btn-payment">Search</button>
        </div>

        {/* Table */}
        <div className="table-container-payment">
          <table className="payment-mode-table">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Paid By User</th>
                <th>Student Name</th>
                <th>Transaction Id</th>
                <th>Transaction Amount</th>
                <th>Transaction Mode</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="6" className="no-results-payment">
                  No results found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Payment_Mode_Report;
